import { GlobalStyles, useTheme } from "@mui/material";

const CustomGlobalStyles = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <GlobalStyles
      styles={{
        "*": {
          transition: theme.transitions.create(
            ["background-color", "color", "border-color"],
            {
              duration: theme.transitions.duration.standard,
              easing: theme.transitions.easing.easeInOut,
            }
          ),
        },
        body: {
          transition: `${theme.transitions.create(
            ["background-color", "transform"],
            {
              duration: theme.transitions.duration.complex,
            }
          )}`,
        },
        "*::-webkit-scrollbar": {
          width: "0.45em",
          height: "0.6em",
        },
        "*::-webkit-scrollbar-track": {
          background: isDark ? "#332D41" : "#FFFFFF",
          borderRadius: 8,
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: isDark ? "#938F99" : "#797677",
          borderRadius: 100,
        },
      }}
    />
  );
};

export default CustomGlobalStyles;
